import { gql } from '@apollo/client';

export const UPSERT_ISFAVORITE = gql`
  mutation upsertIsFavorite($input: UpsertInsightInput!) {
    insight: upsertIsFavorite(input: $input) {
      id
    }
  }
`;
